<template>
  <form id="search-form" class="search-form" v-on:submit.prevent="(event) => submitHandler(event, submit)">
    <h3 v-if="mode === 'default'">Search for a code</h3>
    <input name="term" v-bind:value="term" type="text" class="search-form__input placeholder" placeholder="Enter keyword(s) or code"><!--
    --><button type="submit" class="search-form__button" value="Search" form="search-form"
         data-gtm-category="Search" data-gtm-action="Search button" data-gtm-label="Search"></button>
    <div v-if="!helpForSearchTerm && !nbResults" class="search-form__help help">
      <p>Describe the goods or services the business produces or sells, for example ‘clothing retailing’ not ‘retailing’.</p>
      <p>If you are self-employed, describe what you do, for example ‘dairy farming’ not ‘dairy farmer’.</p>
      <p>Need help? See the BIC code <a href="/help/">help page.</a></p>
    </div>
    <div v-if="helpForSearchTerm" v-html="helpForSearchTermEdited" class="search-form__help"></div>
  </form>
</template>

<script>
  import Vue from 'vue';
  import escape from 'escape-html';

  export default Vue.component('SearchForm', {
    props: {
      mode: String,
      term: String,
      nbResults: Number,
      helpForSearchTerm: String,
      submit: Function,
    },
    computed: {
      helpForSearchTermEdited: function() {
        return this.editHelpForSearchTerm(this.helpForSearchTerm, this.nbResults, this.term);
      },
    },
    methods: {
      submitHandler: function(event) {
        const term = event.target.querySelector('input').value;
        this.submit({ term });
      },
      editHelpForSearchTerm: function (helpForSearchTerm, nbResults, term) {
        let editHelpForSearchTermEdited;
        if (nbResults) {
          editHelpForSearchTermEdited = helpForSearchTerm.replace('xxxx', nbResults);
        } else {
          editHelpForSearchTermEdited = helpForSearchTerm.replace('xxxx', escape(term));
        }
        // The link #browse/class/ is hard-coded in the response. Replaces it with /browse/class
        editHelpForSearchTermEdited = editHelpForSearchTermEdited.replace('#browse/class', '/browse/class');
        return editHelpForSearchTermEdited;
      }
    }
  });
</script>